var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickets = function SvgTickets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.04 12.77",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.04 6.84V4.25h-3.57v5.72H4.35v2.59h14.69V9.97c-.87 0-1.57-.7-1.57-1.57s.7-1.57 1.57-1.57ZM4.36.2H0v2.59c.86 0 1.57.7 1.57 1.57S.87 5.92 0 5.92v2.59h4.36V.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.01 8.51v-2.6c-.86 0-1.56-.7-1.56-1.56s.7-1.56 1.56-1.57V.2H5.84v8.3h8.17Z"
  })));
};
export default SvgTickets;